var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Projects',{attrs:{"projects":_vm.aplicacion.projects}}),_c('Statistics',{attrs:{"statistics":_vm.aplicacion.statistics}}),_c('Services',{attrs:{"services":_vm.aplicacion.services}}),_c('Clients',{attrs:{"clients":_vm.aplicacion.clients}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }